import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';

@Component({
    selector: 'dataEngine',
    templateUrl: 'dataEngine.component.html'
})

export class DataEngine {

    public engineOptions: string[] = [
        'DRILL', 'PRESTO', 'KYLIN', 'DRUID',
        'OLAP', 'IMPALA', 'SPARK', 'Clickhouse'];

    public dataEngineReg: string = '';
    public sPage: number = 0;
    public lastRegex: string = '';
    public dataEngineData: any = {
        id: null, name: '', dataEngineCode: null,
        server: '', port: '', username: '', type: '', password: '', deleted: 0
    };

    public mainPage: boolean = true;
    public dataEnginePage: boolean = false;
    public dataEngineList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedEngineId: number;
    public selectedEngineType: string = null;
    public endingPage: number;

    public totalEngines: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;
    public clusterList = [];

    constructor(
        public dataEngineService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.dataEngineService.isBIAdmin) {
            this.loadEngine();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedEngineId == null) {
            this.selectedEngineId = event.target.id;
        } else {
            this.selectedEngineId = null;
        }
    }

    public closeDropDown(event){
        this.selectedEngineId = null;
    }

    // For Pagination
    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dataEngineReg != '') {
            this.searchPDataEngine();
        } else {
            this.loadEngine();
        }
        this.setEndingPage(this.totalEngines);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalEngines / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadEngine();
    }

    public loadEngine() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.dataEngineService.getDataByPage(BiUrls.DATAENGINE, self.pageNo, self.pageSize).then((res) => {
                self.dataEngineList = [];
                self.totalEngines = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.dataEngineList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalEngines = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalEngines);
                self.loader = false;
                resolve('completed');
            }, (error) => {
                console.error(error);
            });
        });
    }

    // By Lalu
    public searchPDataEngine() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            self.dataEngineList = [];
            if (self.dataEngineReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dataEngineReg;
            self.dataEngineService.search(BiUrls.DATAENGINE, BiUrls.SEARCH_P_DATAENGINE,
                self.dataEngineReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPDataEngine(res).then(res => {
                        self.loader = false;
                    }, (err) => {
                        console.error(err);
                    });
                });
            resolve('completed');
        })
    }

    // By Lalu
    public loadSearchedPDataEngine(res) {
        let self = this;
        return new Promise((resolve) => {
            if (res != undefined) {
                self.dataEngineList = res.data.pageElements;
                self.totalEngines = res.data.total;
            } else {
                self.totalEngines = 0;
            }
            self.setEndingPage(self.totalEngines);
            resolve('resolved');
        });
    }

    public addNewDataEngine(type) {
        this.mainPage = false;
        this.dataEnginePage = true;
        this.dataEngineData = {
            id: null, name: '', server: '', port: '',
            username: '', type: type, password: '', deleted: 0
        };
        this.clusterList = type == 'DRILL' ? [ { ip: '' , port: ''} ] : [];
    }

    public onSave() {
        let self = this;
        if(self.dataEngineData.type == 'DRILL'){
            this.setDataForDrill()
        }
        
        let validate: any = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            self.saveButton = true;
            if (self.isEdit) {
                self.dataEngineService.update(BiUrls.DATAENGINE, self.dataEngineData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                self.dataEngineService.save(BiUrls.DATAENGINE, self.dataEngineData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalEngines / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        let text = type == 'new' ? 'Data Engine saved successfully' : 'Changes saved successfully';
        if (this.dataEngineReg != '') {
            self.searchPDataEngine().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Data Engine');
                }
            });
        } else {
            self.loadEngine().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError('Unable to save Data Engine');
                }
            }, (error) => {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.dataEnginePage = false;
        self.isEdit = false;
    }

    public clickEdit(engine) {
        let self = this;
        self.loader = true;
        self.dataEngineService.getDataById(BiUrls.DATAENGINE, engine.id).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Engines');
            } else {
                engine = res.data;
                self.selectedEngineType = engine.type;
                self.isEdit = true;
                self.mainPage = false;
                self.dataEnginePage = true;
                self.selectedEngineId = null;
                self.dataEngineData = JSON.parse(JSON.stringify(engine));
                engine.type == 'DRILL' ? self.getDataForDrill() : null;
            }
            self.loader = false;
        }, (error) => {
            console.error(error);
        });
    }

    onSelectEngineType(event) {
        this.selectedEngineType = event.target.value;

    }

    public onBack() {
        this.mainPage = true;
        this.dataEnginePage = false;
        this.dataEngineData = {};
        this.selectedEngineId = null;
        this.isEdit = false;
    }

    public delete(engine) {
        let self = this;
        self.dataEngineService.delete(BiUrls.DATAENGINE, engine.id).then((response) => {
            if (response.error == undefined) {
                self.toastr.showSuccess(engine.name + ' removed successfully');
            } else {
                self.toastr.showError('Unable to remove Data Engine');
            }
            self.pageNo = self.dataEngineList.length == 1 ?
                self.totalEngines == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadEngine();
        }, (error) => {
            console.error(error);
        });
    }

    public removeEngine(engine) {
        let r = confirm('Are you sure you want to remove the Data Engine ' + engine.name + ' ?');
        if (r == true) {
            this.delete(engine);
        }
    }

    public validater() {
        if (this.dataEngineData.name == undefined || this.dataEngineData.name.trim() == '') {
            return 'Please enter the name for Data Engine';
        }
        if (this.dataEngineData.server == undefined || this.dataEngineData.server.trim() == '') {
            return 'Please enter the server for Data Engine';
        }
        if (this.dataEngineData.type == 'DRILL' && this.clusterList.length != (this.dataEngineData.server.split(',').length)) {
            return 'Please enter the server IP for Cluster';
        }
        //if (this.dataEngineData.port == undefined || this.dataEngineData.port.trim() == '') {
        if (this.dataEngineData.port == undefined) {
            return 'Please enter the port for Data Engine';
        }
        if(this.dataEngineData.port > 65535){
            return 'Please enter the port value between 0 to 65535';
        }

        if(!(this.dataEngineData.type == 'SSAS' && this.dataEngineData.customParameter1)) {
            if (this.dataEngineData.username == undefined ||
                this.dataEngineData.username.trim() == '') {
                return 'Please enter the username for Data Engine';
            }
            if (!this.isEdit) {
                if (this.dataEngineData.newPassword == undefined ||
                    this.dataEngineData.newPassword.trim() == '') {
                    return 'Please enter the password for Data Engine';
                }
            }
            this.dataEngineData.username = this.dataEngineData.username.trim();
        }

        this.dataEngineData.name = this.dataEngineData.name.trim();
        this.dataEngineData.server = this.dataEngineData.server.trim();
        this.dataEngineData.port = this.dataEngineData.port.toString();
        //this.dataEngineData.type = this.dataEngineData.type.trim();
        
        return '';

    }

    getDataForDrill(){
        if(this.dataEngineData.server && this.dataEngineData.server.match(/,/g)){
            let clusters = this.dataEngineData.server.split(',');
            this.dataEngineData['customParameter2'] = !!this.dataEngineData['customParameter2'] ? 
                this.dataEngineData.customParameter2 : clusters[0].split(':')[0];
            this.dataEngineData['customParameter1'] = !!this.dataEngineData['customParameter1'] ?
                this.dataEngineData.customParameter1 : '';
            let clusterList = [];
            if(clusters && clusters.length > 1){
                clusters.forEach(cluster=>{
                    let clusterDet;
                    if(cluster && cluster.match(/:/g)){
                        clusterDet = cluster.split(':');
                        clusterList.push({ ip : clusterDet[0], port: clusterDet[1] });
                    }else{
                        clusterList.push({ ip : cluster, port: '' });
                    }
                });
            }
            this.clusterList = clusterList;
        }else if(this.dataEngineData.server && !this.dataEngineData.server.match(/,/)){
            this.dataEngineData['customParameter2'] = this.dataEngineData.server;
            this.clusterList = [ { ip: this.dataEngineData.server, port: '' } ];
        }
    }

    setDataForDrill(){
        let serverList = [];
        this.clusterList.forEach(cluster=>{
            if(cluster.ip && cluster.ip.trim() != ''){
                let str:string = cluster.ip;
                str += (cluster.port && cluster.port != '') ? ':' + cluster.port : '';
                serverList.push(str);
            }
        });
        this.dataEngineData.server = serverList.join();
    }

    enableWinAuthAction(event) {
        if(event.target.checked){
            this.dataEngineData.username = "";
            this.dataEngineData.newPassword = "";
        }
    }

    addCluster(){
        this.clusterList.push({ip: '', port: ''});
    }

    removeCluster(index){
        this.clusterList.splice(+index,1);
    }

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dataEngine.component.ts